import React, { useState, useEffect } from "react";

import {
  Grid,
  FormControl,
  FormControlLabel,
  FormLabel,
  Radio,
  RadioGroup,
  Typography,
  Box,
  Checkbox,
} from "@material-ui/core";
import { TextValidator, ValidatorForm } from "react-material-ui-form-validator";
import { MuiPickersUtilsProvider } from "@material-ui/pickers";
import ValidatedDatePicker from "../../compartidos/ValidatedDatePicker";
import DateFnsUtils from "@date-io/date-fns";
import esLocale from "date-fns/locale/es";
import moment from "moment";
import "moment/locale/es";
import { useDispatch, useSelector } from "react-redux";
import { getDatosAfiliadosRecuperoAutorizador } from "../../../actions/autorizaciones/Autorizaciones";

const FormSolicitudPractica = (props) => {

  const dispatch = useDispatch();

  const { afiliadoSeleccionado, afiliadosRecupero } = useSelector((state) => state.autorizaciones);

  const {
    celular,
    conInternacion,
    fechaPrescripcion,
    fechaProgramada,
    idMotivoInternacion = "0",
    telefono,
  } = props.formValues;

  const [conInternacionValue, setConInternacionValue] = useState(
    conInternacion ? "internacion" : "ambulatorio"
  );

  useEffect(() => {
    //FechaPrescripcion
    ValidatorForm.addValidationRule("isAfterToday", (value) => {
      if (!moment(value).isValid() || moment(value).isAfter(moment(), "day")) {
        return false;
      }
      return true;
    });

    //FechaProgramada
    ValidatorForm.addValidationRule("isBeforeFechaPrescripcion", (value) => {
      if (
        !moment(value).isValid() ||
        moment(value).isBefore(moment(fechaPrescripcion), "day")
      ) {
        return false;
      }
      return true;
    });

    //FechaProgramada
    ValidatorForm.addValidationRule("isBeforeToday", (value) => {
      if (!moment(value).isValid() || moment(value).isBefore(moment(), "day")) {
        return false;
      }
      return true;
    });

  }, []);

  useEffect(() => {
    dispatch(getDatosAfiliadosRecuperoAutorizador(afiliadoSeleccionado?.id_afiliado))
  }, [afiliadoSeleccionado])


  const handleDayClick = fechaProgramada => {
    if (moment(fechaProgramada).isSameOrBefore(moment(afiliadoSeleccionado?.fecha_fin_cobertura).add(1, 'days')) || afiliadoSeleccionado?.fecha_fin_cobertura === null) {
      props.setFechaSeleccionada(false)
    } else {
      props.setFechaSeleccionada(true)
    }
  }

  console.log(afiliadosRecupero)
  console.log(afiliadoSeleccionado)
  return (
    <React.Fragment>
      <Grid
        item
        xs={12}
        style={{
          display: "flex",
          justifyContent: "center",
          marginTop: ".7rem",
        }}
      >
        <RadioGroup
          row
          value={conInternacionValue}
          defaultValue={conInternacionValue}
          onChange={(e) => {
            props.setHaveChangeValues(true);
            setConInternacionValue(e.target.value);
            props.setearVariosValores({
              conInternacion: e.target.value === "internacion",
              idMotivoInternacion: "0",
              fechaPrescripcion: "",
              fechaProgramada: "",
              telefono: "",
              celular: "",
            });
          }}
        >
          <FormControlLabel
            value={"ambulatorio"}
            control={<Radio />}
            label="Ambulatoria"
          />
          <FormControlLabel
            value={"internacion"}
            control={<Radio />}
            label="Con internación"
          />
        </RadioGroup>
      </Grid>
      <React.Fragment>
        {conInternacion && (
          <Grid container spacing={2}>
            <Grid item xs={6}>
              <MuiPickersUtilsProvider locale={esLocale} utils={DateFnsUtils}>
                <ValidatedDatePicker
                  fullWidth={true}
                  margin="normal"
                  format="dd/MM/yyyy"
                  okLabel="Aceptar"
                  clearLabel="Limpiar"
                  cancelLabel="Cancelar"
                  label="Fecha Prescripción"
                  name="fechaPrescripcion"
                  value={
                    fechaPrescripcion !== undefined &&
                      moment(fechaPrescripcion).isValid()
                      ? moment(fechaPrescripcion)
                      : null
                  }
                  onChange={(e) => {
                    props.setHaveChangeValues(true);
                    props.setearValor("fechaPrescripcion", e);
                  }}
                  KeyboardButtonProps={{
                    "aria-label": "change date",
                  }}
                  maxDate={new Date()}
                  validators={
                    props.practicaElegida?.requiereFechaPrescripcion && [
                      "required",
                      "isAfterToday",
                    ]
                  }
                  errorMessages={
                    props.practicaElegida?.requiereFechaPrescripcion && [
                      "La fecha de prescripción es requerida",
                      "La fecha de prescripción no puede ser mayor a la fecha actual",
                    ]
                  }
                />
              </MuiPickersUtilsProvider>
            </Grid>
            <Grid item xs={6}>
              <MuiPickersUtilsProvider locale={esLocale} utils={DateFnsUtils}>
                <ValidatedDatePicker
                  fullWidth={true}
                  margin="normal"
                  format="dd/MM/yyyy"
                  okLabel="Aceptar"
                  clearLabel="Limpiar"
                  cancelLabel="Cancelar"
                  label="Fecha Programada"
                  name="fechaProgramada"
                  value={
                    fechaProgramada !== undefined &&
                      moment(fechaProgramada).isValid()
                      ? moment(fechaProgramada)
                      : null
                  }
                  onChange={(e) => {
                    props.setHaveChangeValues(true);
                    props.setearValor("fechaProgramada", e);
                    handleDayClick(e);
                  }}
                  KeyboardButtonProps={{
                    "aria-label": "change date",
                  }}
                  minDate={fechaPrescripcion}
                  validators={
                    props.practicaElegida?.requiereFechaProgramada && [
                      "required",
                      "isBeforeFechaPrescripcion",
                      "isBeforeToday",
                    ]
                  }
                  errorMessages={
                    props.practicaElegida?.requiereFechaProgramada && [
                      "La fecha programada es requerida",
                      "La fecha programada no puede ser menor a la fecha fecha de prescripción",
                      "La fecha programada no puede ser menor a la fecha actual",
                    ]
                  }
                />
              </MuiPickersUtilsProvider>
            </Grid>
          </Grid>
        )}
        <Box
          display="flex"
          xs={12}
          style={{ marginTop: "0.5rem", marginLeft: "1rem" }}
        >
          <Grid
            item
            xs={6}
            style={{ marginTop: "1.5rem", marginLeft: "1rem" }}
          >
            <FormControlLabel
              control={
                <Checkbox
                  checked={afiliadosRecupero.length > 0}
                  disabled
                />
              }
              label={
                <Typography
                  style={{
                    color: afiliadosRecupero.length > 0 ? "red" : "black",
                    fontWeight: afiliadosRecupero.length > 0 ? "bold" : "normal",
                  }}
                >
                  Afiliado en Recupero
                </Typography>
              }
            />

          </Grid>
        </Box>
        <Box
          display="flex"
          xs={12}
          style={{ marginTop: "1.5rem", marginLeft: "1rem" }}
        >

          <Grid
            item
            xs={6}
            style={{ marginTop: "1.5rem", marginLeft: "1rem" }}
          >
            <FormControl>
              <FormLabel>Motivo de internación:</FormLabel>
              <RadioGroup
                value={idMotivoInternacion?.toString()}
                defaultValue={idMotivoInternacion?.toString()}
                onChange={(e) => {
                  props.setHaveChangeValues(true);
                  props.setearVariosValores({
                    idMotivoInternacion: e.target.value,
                    telefono: e.target.value === "4" ? "" : telefono,
                    celular: e.target.value === "4" ? "" : celular,
                  });
                }}
              >
                <FormControlLabel
                  value={"1"}
                  control={<Radio />}
                  label="Accidente en via pública"
                />
                <FormControlLabel
                  value={"2"}
                  control={<Radio />}
                  label="Accidente de trabajo"
                />
                <FormControlLabel
                  value={"3"}
                  control={<Radio />}
                  label="Otro tipo de accidente con denuncia policial"
                />
                <FormControlLabel
                  value={"4"}
                  control={<Radio />}
                  label="Ninguno"
                />
              </RadioGroup>
            </FormControl>
          </Grid>
          <Grid item xs={6} style={{ marginTop: 10 }}>
            {(!fechaProgramada ||
              moment(fechaProgramada).isSameOrBefore(moment(afiliadoSeleccionado?.fecha_fin_cobertura).add(1, 'days')) ||
              afiliadoSeleccionado?.fecha_fin_cobertura === null)
              ? null
              : <Typography color="error" align="center">Beneficiario/a con cobertura inactiva  para la fecha seleccionada</Typography>
            }
          </Grid>
        </Box>
        {idMotivoInternacion &&
          parseInt(idMotivoInternacion) > 0 &&
          parseInt(idMotivoInternacion) < 4 && (
            <React.Fragment>
              <Grid container spacing={2}>
                <Grid item xs={6}>
                  <TextValidator
                    fullWidth
                    margin="normal"
                    label="Tel. Particular(10 dígitos sin el 0)"
                    name="telefono"
                    value={telefono}
                    onChange={(e) => {
                      props.setHaveChangeValues(true);
                      props.handleInputChange(e);
                    }}
                    validators={
                      celular === ""
                        ? [
                          "required",
                          "isNumber",
                          "maxNumber:9999999999",
                          "minNumber:999999999",
                        ]
                        : [
                          "isNumber",
                          "maxNumber:9999999999",
                          "minNumber:999999999",
                        ]
                    }
                    errorMessages={
                      celular === ""
                        ? [
                          "El teléfono es requerido",
                          "Sólo números",
                          "Verifique su teléfono",
                          "Verifique su teléfono",
                        ]
                        : [
                          "Sólo números",
                          "Verifique su teléfono",
                          "Verifique su teléfono",
                        ]
                    }
                  />
                </Grid>
                <Grid item xs={6}>
                  <TextValidator
                    fullWidth
                    margin="normal"
                    label="Tel. Celular(10 dígitos sin 0 ni 15)"
                    name="celular"
                    value={celular}
                    onChange={(e) => {
                      props.setHaveChangeValues(true);
                      props.handleInputChange(e);
                    }}
                    maxLength="10"
                    validators={
                      telefono === ""
                        ? [
                          "required",
                          "isNumber",
                          "maxNumber:9999999999",
                          "minNumber:999999999",
                        ]
                        : [
                          "isNumber",
                          "maxNumber:9999999999",
                          "minNumber:999999999",
                        ]
                    }
                    errorMessages={
                      telefono === ""
                        ? [
                          "El celular es requerido",
                          "Sólo números",
                          "Verifique su celular",
                          "Verifique su celular",
                        ]
                        : [
                          "Sólo números",
                          "Verifique su celular",
                          "Verifique su celular",
                        ]
                    }
                  />
                </Grid>
              </Grid>
            </React.Fragment>
          )}
      </React.Fragment>
    </React.Fragment>
  );
};

export default FormSolicitudPractica;
